"use strict";

var _regeneratorRuntime = require("/root/ui-api/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.promise.js");

var _asyncKeychain = require("./asyncKeychain");

var _misc = require("../utils/misc");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function waitForKc() {
  return _waitForKc.apply(this, arguments);
}

function _waitForKc() {
  _waitForKc = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var init, i;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(typeof document === 'undefined' || !document.getElementById('golos_keychain_inpage'))) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", false);

          case 2:
            init = false;
            i = 0;

          case 4:
            if (!(i < 200)) {
              _context.next = 13;
              break;
            }

            init = typeof window.golosKeychain !== 'undefined';

            if (!init) {
              _context.next = 8;
              break;
            }

            return _context.abrupt("break", 13);

          case 8:
            _context.next = 10;
            return (0, _misc.delay)(10);

          case 10:
            ++i;
            _context.next = 4;
            break;

          case 13:
            if (init) {
              _context.next = 15;
              break;
            }

            throw new Error('Golos Keychain extension is broken due to some bug');

          case 15:
            return _context.abrupt("return", true);

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _waitForKc.apply(this, arguments);
}

function assertKc() {
  return _assertKc.apply(this, arguments);
}

function _assertKc() {
  _assertKc = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return waitForKc();

          case 2:
            if (_context2.sent) {
              _context2.next = 4;
              break;
            }

            throw new Error('Golos Keychain extension is not installed or disabled');

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _assertKc.apply(this, arguments);
}

function kcLogin() {
  return _kcLogin.apply(this, arguments);
}

function _kcLogin() {
  _kcLogin = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3() {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return assertKc();

          case 2:
            _context3.next = 4;
            return _asyncKeychain.singles.login();

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _kcLogin.apply(this, arguments);
}

function kcLoggedIn() {
  return _kcLoggedIn.apply(this, arguments);
}

function _kcLoggedIn() {
  _kcLoggedIn = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4() {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return waitForKc();

          case 2:
            if (_context4.sent) {
              _context4.next = 4;
              break;
            }

            return _context4.abrupt("return", {
              authorized: false
            });

          case 4:
            _context4.next = 6;
            return _asyncKeychain.singles.loggedIn();

          case 6:
            return _context4.abrupt("return", _context4.sent);

          case 7:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _kcLoggedIn.apply(this, arguments);
}

function kcLogout() {
  return _kcLogout.apply(this, arguments);
}

function _kcLogout() {
  _kcLogout = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee5() {
    var state;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return kcLoggedIn();

          case 2:
            state = _context5.sent;

            if (!(state && state.authorized)) {
              _context5.next = 7;
              break;
            }

            _context5.next = 6;
            return _asyncKeychain.singles.logout();

          case 6:
            return _context5.abrupt("return", true);

          case 7:
            return _context5.abrupt("return", false);

          case 8:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _kcLogout.apply(this, arguments);
}

function kcSign(_x) {
  return _kcSign.apply(this, arguments);
}

function _kcSign() {
  _kcSign = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee6(_ref) {
    var tx;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            tx = _ref.tx;
            _context6.next = 3;
            return assertKc();

          case 3:
            _context6.next = 5;
            return _asyncKeychain.singles.sign({
              tx: tx
            });

          case 5:
            return _context6.abrupt("return", _context6.sent);

          case 6:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _kcSign.apply(this, arguments);
}

module.exports = {
  kcLogin: kcLogin,
  kcLoggedIn: kcLoggedIn,
  kcLogout: kcLogout,
  waitForKc: waitForKc,
  assertKc: assertKc,
  kcSign: kcSign
};